// extracted by mini-css-extract-plugin
module.exports = {"root":"LvzqCuY6","flexColumn":"f4JCvSxJ","titleLabel":"sRhWAeHf","tickerLabel":"vicNvQr6"};